export enum DateRangeType {
  OneDay = 'One Day',
  Week = 'Week',
  TwoWeeks = '2 Weeks',
  ThreeWeeks = '3 Weeks',
  Month = 'Month',
  SixWeeks = '6 Weeks',
  ThreeMonths = '3 Months',
  Year = 'Year',
  Project = 'Project',
}

export interface DateRange {
  start: Date | null // null means no start date filter (entire project)
  end: Date
  type: DateRangeType
}
